var _rect, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBgRedLocation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "#F70303"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4522_31152)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24 13.5C21.8127 13.5025 19.7157 14.3725 18.1691 15.9191C16.6225 17.4657 15.7525 19.5627 15.75 21.75C15.75 28.8094 23.25 34.1409 23.5697 34.3641C23.6958 34.4524 23.846 34.4998 24 34.4998C24.154 34.4998 24.3042 34.4524 24.4303 34.3641C24.75 34.1409 32.25 28.8094 32.25 21.75C32.2475 19.5627 31.3775 17.4657 29.8309 15.9191C28.2843 14.3725 26.1873 13.5025 24 13.5ZM24 18.75C24.5933 18.75 25.1734 18.9259 25.6667 19.2556C26.1601 19.5852 26.5446 20.0538 26.7716 20.6019C26.9987 21.1501 27.0581 21.7533 26.9424 22.3353C26.8266 22.9172 26.5409 23.4518 26.1213 23.8713C25.7018 24.2909 25.1672 24.5766 24.5853 24.6924C24.0033 24.8081 23.4001 24.7487 22.8519 24.5216C22.3038 24.2946 21.8352 23.9101 21.5056 23.4167C21.1759 22.9234 21 22.3433 21 21.75C21 20.9544 21.3161 20.1913 21.8787 19.6287C22.4413 19.0661 23.2044 18.75 24 18.75Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4522_31152"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(12 12)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBgRedLocation);
export default __webpack_public_path__ + "static/media/BgRedLocation.864f0322a2f03b54544811e1a29cb0dd.svg";
export { ForwardRef as ReactComponent };